import React, {Component} from 'react'

import {
    css,
    Icon,
    Nav,
    NavLink,
} from "@bdfx/mergado-ui-kit"

import trans from "trans";
import {eshopId, projectId} from "app/helpers/api";
import { Link } from "react-router-dom"
import {AdminMenuItems, AdminMenuType} from "../containers";
import { URL } from 'app/config/api-config';

interface Props {
    activeMenuItem: AdminMenuType
}

class SuperadminMenu extends Component<Props> {
    constructor(props) {
        super(props)
    }

    getIconByItem = (menuItem : AdminMenuType) => {
        switch (menuItem) {
            case 'projects_overview':
                return <Icon type={'bar-chart'} size={iconSize} text={trans(menuItem)} />
            case 'project_health':
                return <Icon type={'heartbeat'} size={iconSize} text={trans(menuItem)} />
            case 'find_by':
                return <Icon type={'search'} size={iconSize} text={trans(menuItem)} />
            case 'audit_promo_templates':
                return <Icon type={'feedimageeditor'} size={iconSize} text={trans(menuItem)} />
            case 'system':
                return <Icon type={'line-chart'} size={iconSize} text={trans(menuItem)} />
            case 'project_info':
                return <Icon type={'user'} size={iconSize} text={trans(menuItem)} />
            case 'random_images':
                return <Icon type={'random'} size={iconSize} text={trans(menuItem)} />
            case 'rules':
            case 'queries':
            case 'mergado_products':
            case 'mergado_formats':
            case 'mergado_elements':
                return <Icon type={'mergado'} size={iconSize} text={trans(menuItem)} />
            case 'products':
                return <Icon type={'image-light'} size={iconSize} text={trans(menuItem)} />
            case 'templates':
                return <Icon type={'image-light'} size={iconSize} text={trans(menuItem)} />
            case 'rabbit':
                return <Icon type={'area-chart'} size={iconSize} text={trans(menuItem)} />
            case 'mcp':
                return <span>
                    <img src={`${URL.publicPath}img/icons/profitak.ico`} width={iconSize} height={iconSize} className={'icon-img'} /> {trans(menuItem)}
                </span>
            default:
                return <Icon type={'search'} size={iconSize} text={trans(menuItem)} />
        }
    }

    render() {
        const {activeMenuItem} = this.props

        return <StyledNav title={'show'}>
            {AdminMenuItems.map((menuItem: AdminMenuType) => {
                return <NavLink
                    key={menuItem}
                    active={activeMenuItem === menuItem}
                    link={
                        <Link to={`/eshop/${eshopId}/project/${projectId}/superadmin/${menuItem}`}>
                            {this.getIconByItem(menuItem)}
                        </Link>
                    } />
            }
            )}
        </StyledNav>
    }
}

const iconSize = 24
const StyledNav = css(Nav)({
    marginTop: '-3px !important',
})

export default SuperadminMenu